export const PLATFORM_LOAD_SUCCESS = "PLATFORM_LOAD_SUCCESS"
